import axiosClient from "../axiosClient";
import API_MAP from "../../constants/api";

class ApiManagerNotification {
    getAllNotification = (userName, limit = 10, idLargestRoom = 0) => {
        return axiosClient.get(API_MAP.ALL_NOTIFICATION + '/' + userName + '/' + idLargestRoom + '/' + limit)
    }

    updateManyNotificationStatus = (data) => {
        return axiosClient.post(API_MAP.UPDATE_NOTIFICATION_STATUS, data)
    }

    updateAllNotificationStatus = (data) => {
        return axiosClient.post(API_MAP.UPDATE_ALL_NOTIFICATION_STATUS, data)
    }

    checkUserStillInRoom = (data) => {
        return axiosClient.put(API_MAP.CHECK_USER_STILL_IN_ROOM, data)
    }
  
}

const apiManagerNotification = new ApiManagerNotification();

export default apiManagerNotification;